/* eslint-disable */
/* tslint:disable */

/** getCalendarMonthSchedule
 * method: get
 * summary: Get hubler offers, missions and unavailabilities for a complete month
 */

import type {
  GetCalendarMonthScheduleResponseDto,
  BadRequestResponseDto,
  ApiResponseDto,
} from './../api-types'

export const path = `/bff-worker/calendar/month`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/calendar/month`

export type GetCalendarMonthScheduleSuccess =
  GetCalendarMonthScheduleResponseDto
export type GetCalendarMonthScheduleError =
  | BadRequestResponseDto
  | ApiResponseDto
